import styled from 'styled-components';
import { Media } from 'enums';

export const PaginationItem = styled.div<{
  active: boolean;
  isTouchStart: boolean;
}>`
  width: 35px;
  height: 35px;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${({ active, theme, isTouchStart }) => {
    if (isTouchStart) {
      return active ? theme.colors.yellow2 : theme.colors.white;
    }

    return active ? theme.colors.yellow1 : 'none';
  }};

  @media ${Media.notebook} {
    width: 40px;
    height: 40px;

    :hover {
      background-color: ${({ active, theme }) =>
        active ? theme.colors.yellow3 : theme.colors.white};
    }

    :active {
      background-color: ${({ active, theme }) =>
        active ? theme.colors.yellow2 : theme.colors.white};
    }
  }
`;
